import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { addPageObject, addPageObjectOffline } from "../../../../store/actions/pages";
import withLayout from "../../common/layout";
import { AddButton, BoxDiv, CalendarBox, CalendarTable, Count, DashboardSection, DayCell, DropTarget, EmployeeCell, EmployeeCellTD, IconWrapper, SettingsBox, Tile, Title, TitleBox } from "./styles";
import { GetIcon } from "../../../../icons";
import { useTranslation } from "react-i18next";
import { convertMinutesToHHMM, formatDateToDayAndDate } from "../../../functions/dataFormat";
import { Container } from "../../common/layout/styels";
import moment from "moment";
import { generateThumbnail } from "../../../functions/string";
import { Filter1 } from "../../../elements/dateselector/styles";
import { NoData, ToggleContainer, ToggleInput, ToggleSlider } from "../../../elements/list/styles";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { getData, postData } from "../../../../backend/api";
import Checkbox from "../../../elements/checkbox";
import PopupView from "../../../elements/popupview";
import { dateFormat } from "../../../functions/date";
import i18n from "i18next";
import { udpateLogin } from "../../../../store/actions/login";
import { Link, useNavigate } from "react-router-dom";
import { DisplayInformations } from "../../../elements/list/popup";
const Dashboard = (props) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const themeColors = useSelector((state) => state.themeColors);
  const [initialized, setInitialized] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [organisedData, setOrganisedData] = useState({});
  const [dashboardDefault, setDashboardDefault] = useState([]);
  const [leavesData, setLeavesData] = useState({});
  const [currentDate, setCurrentDate] = useState(moment());
  const dashboard = useSelector((state) =>
    state.pages[`dashboard/employee`]
      ? state.pages[`dashboard/employee`]
      : {
          data: null,
          isLoading: true,
          error: null,
        }
  );
  const userData = useSelector((state) => state.login)
  let user = userData?.data?.user;
  let date = new Date();
  const [selectedLanguage] = useState(i18n.language || "de");
  const dashboardOrder = useSelector((state) => (state.pages[`dashboardOrder`] ? state.pages[`dashboardOrder`] : []));
  // const [birthdays, setBirthday] = useState(dashboard?.data?.birthdays ?? []);
  // const [leaves, setLeaves] = useState(dashboard?.data?.leaves ?? []);
  useEffect(() => {
    // setBirthday(dashboard?.data?.birthdays ?? []);
    // setLeaves(dashboard?.data?.leaves ?? []);
    const data = {};
    if (dashboard?.data?.dashboard) {
      data["status"] = dashboard?.data?.status;
    }
    if (dashboard?.data?.leaves) {
      data["leave"] = dashboard?.data?.leaves;
    }
    if (dashboard?.data?.news) {
      data["news"] = dashboard?.data?.news;
    }
    if (dashboard?.data?.leaveRequest) {
      data["leaveRequest"] = dashboard?.data?.leaveRequest;
    }
    setOrganisedData(data);
    setDashboardDefault(dashboard?.data?.dashboardDefault ?? []);
    console.log(dashboard);
  }, [dashboard]);

  useEffect(() => {
    props.setLoaderBox(dashboard.isLoading);
    dashboard.isLoading && setInitialized(true);
  }, [dashboard]);

  useEffect(() => {
    if (initialized) {
      dispatch(addPageObject("dashboard/employee", 0, {}));
    }
  }, [initialized, dispatch]);

  useEffect(() => {}, [dashboard]);
  const GetValue = (type, itemValue) => {
    switch (type) {
      case "minute":
        return convertMinutesToHHMM(parseFloat(itemValue ?? 0));
      default:
        return itemValue ?? 0;
    }
  };
  const ArrowAction = async (direction) => {
    const newDate = moment(currentDate).add(direction, "month");
    const data = await getData({ currentDate: newDate.toISOString() }, "dashboard/leaves", dispatch, navigate);
    setLeavesData(data.data);
    setCurrentDate(newDate);
  };
  const getMonthDays = () => {
    const startOfMonth = moment(currentDate).startOf("month");
    const endOfMonth = moment(currentDate).endOf("month");
    const daysInMonth = [];

    let currentDay = startOfMonth;

    while (currentDay.isSameOrBefore(endOfMonth, "day")) {
      daysInMonth.push(moment(currentDay));
      currentDay.add(1, "day");
    }

    return daysInMonth;
  };
  const DraggableDashboard = ({ data, className = "", index }) => {
    const [isDragging, setIsDragging] = useState(false);
    const [isdrop, setIsDrop] = useState(false);
    const [over, setOver] = useState(false);

    const [, drag] = useDrag({
      type: "ITEM",
      item: { index: index }, // Use 'item' to specify the data being dragged
      collect: (monitor) => {
        setIsDragging(monitor.isDragging());
        return {};
      },
    });

    return (
      <>
        {/* <div> </div> */}
        <BoxDiv style={{position:'relative',borderRadius:'10px',border:'2px solid #d6e0ff'}}>
          <div style={{position:'absolute',left:0,right:0,top:0,bottom:0,zIndex: isdrop?10:-1}}>{DropHere(index,setIsDrop,setOver)}</div>

          <BoxDiv style={{visibility: over? 'hidden':'visible', opacity: isDragging ? 0.5 : 1, border:'none',height:'calc(100% - 20px)'}} ref={drag} className="plain">
            <CalendarBox >{data}</CalendarBox>
          </BoxDiv>
        </BoxDiv>
      </>
    );
  };
  const DropHere = (index = 0,setIsDrop,setOver) => {
    const [{ isOver, canDrop }, drop] = useDrop({
      accept: "ITEM",
      hover: (draggedItem) => {
        const draggedIndex = draggedItem.index;
        if (draggedIndex !== index) {
          console.log("no");
        }
      },
      drop: (draggedItem) => {
        // Logic to handle drop event
        console.log(index, draggedItem.index);
        const draggedIndex = draggedItem.index;
        if (draggedIndex !== index) {
          // Swap the dashboards
          const updatedDashboards = [...dashboardOrder];
          // const temp = updatedDashboards[index];
          // updatedDashboards[index] = updatedDashboards[draggedIndex];
          // updatedDashboards[draggedIndex] = temp;
          const draggedItem = updatedDashboards.splice(draggedIndex, 1)[0];

          // Insert the dragged item at the new position
          updatedDashboards.splice(index, 0, draggedItem);
          postData({ dashboardOrder: updatedDashboards }, "admin/update-dashboard", dispatch, navigate);
          dispatch(addPageObjectOffline("dashboardOrder", updatedDashboards ?? []));
          // Update the dashboard state
        }
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    });

    useEffect(() => {
      setIsDrop(canDrop);
      setOver(isOver)
    }, [canDrop,isOver])

    
    

    return (
      (
        <DropTarget
          ref={drop}
          style={{
            backgroundColor: isOver? "white" : "transparent",
            minHeight: "172px",
            border: isOver? "1px dashed #aaa;" : "none",
          }}
        >
          {isOver ? <span>{t("Move here")}</span> : null}
        </DropTarget>
      )
    );
  };

  const generateView = ({ type, data, index }) => {
    console.log(type);
    switch (type) {
      case "leave1":
        return (
          <DraggableDashboard
            key={"item" + index}
            index={index}
            data={
              <>
                <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                  {t("dash-" + type)}
                  <GetIcon icon={"leaveType"} />
                </div>
                <BoxDiv>
                  <CalendarTable>
                    <thead>
                      <tr>
                        <EmployeeCell colSpan={getMonthDays().length}>
                          <Filter1 className="dashboard" theme={props.themeColors}>
                            <div onClick={() => ArrowAction(-1)}>
                              <GetIcon icon={"previous"}></GetIcon>
                            </div>
                            <span> {currentDate && currentDate.format("MMMM Y")}</span>
                            <div onClick={() => ArrowAction(1)}>
                              <GetIcon icon={"next"}></GetIcon>
                            </div>
                          </Filter1>
                        </EmployeeCell>
                      </tr>
                      <tr>
                        {getMonthDays().map((day) => (
                          <DayCell active={day.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")} key={day}>{`${day.format("DD")}`}</DayCell>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {leavesData?.length > 0 &&
                        leavesData?.map((employee) => (
                          <tr key={`${employee.firstName}-${employee.lastName}`}>
                            {getMonthDays().map((day) => {
                              const getFind = employee.leaves?.some((item) => day.format("YYYY-MM-DD") === moment(item.leaveDate).format("YYYY-MM-DD"));
                              return (
                                <DayCell key={`${employee.firstName}-${day.format("DD")}`}>
                                  {getFind && (
                                    <span className="leave" style={{ color: "red" }}>
                                      <GetIcon icon="leaveType" />
                                    </span>
                                  )}
                                </DayCell>
                              );
                            })}
                          </tr>
                        ))}
                    </tbody>
                    {leavesData?.length === 0 && <NoData className="cover">{t("NoLeaves")}</NoData>}
                  </CalendarTable>
                </BoxDiv>
              </>
            }
          />
        );
      case "status":
      case "hourlyStatistics":
        return (
          <DraggableDashboard
            key={"item" + index}
            index={index}
            className="two"
            data={
              dashboard?.data?.[type].length > 0 ? (
                <BoxDiv className="radious">
                  <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                    {t("dash-" + type)}
                    <GetIcon icon={type} />
                  </div>
                  <BoxDiv className="two plain">
                    {dashboard?.data?.[type].map((item, index) =>
                      item.icon === "leavType" ? (
                        <Tile key={`dashboard-${index}`}>
                          <TitleBox>
                            <Count>
                              {item.data.map((count) => (
                                <span className={count.status} key={count.status}>
                                  <GetIcon icon={count.status} />
                                  {GetValue(item.type, count.count ?? 0)}
                                </span>
                              ))}
                            </Count>
                            <Title>{t(item.title)}</Title>
                          </TitleBox>
                        </Tile>
                      ) : (
                        <Tile key={index}>
                          <TitleBox>
                            <Count>{GetValue(item.type, item.count ?? 0)}</Count>
                            <Title>{t(item.title)}</Title>
                          </TitleBox>
                          <IconWrapper style={{ background: item.background, color: item.color }}>
                            <GetIcon icon={item.icon} />
                          </IconWrapper>
                        </Tile>
                      )
                    )}
                  </BoxDiv>
                </BoxDiv>
              ) : null
            }
          />
        );
      case "leave":
        console.log("leaves", data);
        return (
          data && (
            <DraggableDashboard
              key={"item" + index}
              index={index}
              data={
                <>
                  <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                    {t("dash-" + type)}
                    <GetIcon icon={"leaveType"} />
                  </div>
                  <BoxDiv>
                    <CalendarTable>
                      <tbody>
                        {data.length > 0 &&
                          data.map(
                            (employee) =>
                              moment(employee.date).isSameOrAfter(moment()) && (
                                <tr key={`birthday-${employee.firstName} ${employee.lastName}`}>
                                  <DayCell className="align">{`${employee.leaveType[selectedLanguage]}`}</DayCell>
                                  <DayCell key={`${employee.firstName}`}>{moment(employee.date).format("DD MMM")}</DayCell>
                                </tr>
                              )
                          )}
                      </tbody>
                    </CalendarTable>
                    {data.length === 0 && (
                      <BoxDiv>
                        <NoData className="cover">{t("noData")}</NoData>
                      </BoxDiv>
                    )}
                  </BoxDiv>
                </>
              }
            />
          )
        );
      case "leaveRequest":
        return (
          data && (
            <DraggableDashboard
              key={"item" + index}
              index={index}
              data={
                <>
                  <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                    {t("dash-" + type)}
                    <GetIcon icon={"leaveRequest"} />
                  </div>
                  <BoxDiv>
                    <CalendarTable>
                      <thead>
                        <tr>
                          <EmployeeCell>{t("leaveType")}</EmployeeCell>
                          <EmployeeCell className="title">{`${t("date")}`}</EmployeeCell>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length > 0 &&
                          data.map(
                            (leave) =>
                              leave && (
                                <tr key={`request-${leave.user.firstName} ${leave.user.lastName}`}>
                                  <EmployeeCellTD>{`${leave.leaveType[selectedLanguage]}`}</EmployeeCellTD>
                                  <DayCell key={`${leave.user.firstName}`}>{`${moment(leave.startDate).format("DD MMM")} - ${moment(leave.endDate).format("DD MMM")}`}</DayCell>
                                </tr>
                              )
                          )}
                      </tbody>
                    </CalendarTable>
                    {data.length === 0 && (
                      <BoxDiv>
                        <NoData className="cover">{t("noData")}</NoData>{" "}
                      </BoxDiv>
                    )}
                  </BoxDiv>
                </>
              }
            />
          )
        );
      case "news":
        return (
          data && (
            <DraggableDashboard
              key={"item" + index}
              index={index}
              data={
                data.length > 0 ? (
                  <>
                    <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                      <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                        <GetIcon icon={"news"} />
                        {t("dash-" + type)}
                      </div>
                      <Link style={{fontSize:'14px',textDecoration:'none',display:'flex',alignItems:'center',gap:'2px', color: '#3FC4FD'}} to={`/${type}`} >
                      {t("View all")} 
                      <div style={{rotate:"-90deg"}}>
                        <GetIcon
                          fontSize="14px !important"
                          icon={"down"}
                        ></GetIcon>
                        </div>
                      </Link>
                    </div>
                    <BoxDiv>
                      <CalendarTable style={{overflow:"hidden"}}>
                        <thead>
                          <tr>
                            <EmployeeCell className="thead" >{t("message")}</EmployeeCell>
                            <EmployeeCell className="thead">{`${t("createdAt")}`}</EmployeeCell>
                            <EmployeeCell className="thead">{t("addedBy")}</EmployeeCell>
                            <EmployeeCell className="thead">{t("status")}</EmployeeCell>
                            <EmployeeCell className="thead" ></EmployeeCell>
                          </tr>
                        </thead>
                        <tbody>
                          {data.length > 0 &&
                            data.map(
                              (leave,idx) =>
                                leave && (
                                  <tr key={`news-${idx}`}>
                                    <DayCell className="left">{leave?.news?.length > 15 ? (leave?.news?.slice(0,15) + "...") : leave?.news}</DayCell>
                                    <DayCell className="left">{dateFormat(leave.createdAt)}</DayCell>
                                    <DayCell className="left">{`${leave.addedBy.fullName}`}</DayCell>
                                    <DayCell className="left">{t(leave.status)}</DayCell>
                                    <DayCell onClick={()=> handleOpenNews(leave)} style={{rotate:"-90deg",cursor:"pointer"}}><GetIcon icon={"down"} /></DayCell>
                                    
                                  </tr>
                                )
                            )}
                        </tbody>
                      </CalendarTable>
                    </BoxDiv>
                  </>
                ) : (
                  <BoxDiv>
                    <NoData className="cover">{t("noData")}</NoData>
                  </BoxDiv>
                )
              }
            />
          )
        );
      case "leave2":
        return (
          data && (
            <DraggableDashboard
              key={"item" + index}
              index={index}
              data={
                <>
                  <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                    {t("dash-" + type)}
                    <GetIcon icon={"leaveType"} />
                  </div>
                  <BoxDiv>
                    <CalendarTable>
                      <thead>
                        <tr>
                          <EmployeeCell>{t("employee")}</EmployeeCell>
                          <EmployeeCell>{t("leaveType")}</EmployeeCell>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length > 0 &&
                          data.map(
                            (leave) =>
                              leave && (
                                <tr key={`${leave.user.firstName} ${leave.user.lastName}`}>
                                  <EmployeeCellTD className="align">
                                    {generateThumbnail(`${leave.user.firstName} ${leave.user.lastName}`, true, leave.user.photo)}
                                    {`${leave.user.firstName} ${leave.user.lastName}`}
                                  </EmployeeCellTD>
                                  <EmployeeCellTD>{`${leave.leaveType.en}`}</EmployeeCellTD>
                                </tr>
                              )
                          )}
                      </tbody>
                    </CalendarTable>
                    {data.length === 0 && (
                      <BoxDiv>
                        <NoData className="cover">{t("noData")}</NoData>{" "}
                      </BoxDiv>
                    )}
                  </BoxDiv>
                </>
              }
            />
          )
        );
      default:
        return (
          <DraggableDashboard
            key={"item" + index}
            index={index}
            data={
              <BoxDiv>
                <NoData className="cover">{t("notFound", { page: t(type) })}</NoData>
              </BoxDiv>
            }
          />
        );
    }
  };
  const addDashboard = async (title) => {
    let updatedDashboards = [...dashboardOrder];

    // Check if the title is already in the dashboardOrder
    const index = updatedDashboards.findIndex((item) => item === title);
    console.log(index);
    if (index === -1) {
      // If not in the array, add it
      updatedDashboards.push(title);
    } else {
      // If already in the array, remove it
      updatedDashboards = updatedDashboards.filter((item, i) => i !== index);
    }
    console.log(updatedDashboards);
    dispatch(addPageObjectOffline("dashboardOrder", updatedDashboards ?? []));
    // Assuming postData and setDashboardOrder are defined elsewhere in your code
    await postData({ dashboardOrder: updatedDashboards }, "admin/update-dashboard", dispatch, navigate);
  };

const changeClock = async (event)=> {
  props.setLoaderBox(true);
  try {
    const response = await postData({ status: event.target.checked }, `attendance/mark/${user?._id}`, dispatch, navigate);
    if (response.status === 200) {
      if (response.data?.message) {
        props.setMessage({
          type: 1,
          content: t(response.data?.message),
          proceed: t("okay"),
          code: 200,
        });
        const updatedUser = { ...userData?.data };
        updatedUser.user.boardStatus = response.data?.message === "inMarked";
        dispatch(udpateLogin(updatedUser));
      }
    } else {
      props.setMessage({
        type: 1,
        content: t("error"),
        proceed: "Okay",
        code: 500,
      });
    }
  } catch (error) {
    alert(error);
  } finally {
    props.setLoaderBox(false);
  }
}

const [openData, setOpenData] = useState(null);
  const [isOpenPop, setIsOpenPop] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [openDataTitle, setOpenDataTitle] = useState("");

const handleOpenNews = (news) => {
  console.log(news);
  setOpenDataTitle(news.title);
  setOpenData(news);
  setAttributes([
    {
      type: "date",
      placeholder: "createdAt",
      name: "createdAt",
      validation: "",
      default: "",
      label: "createdAt",
      required: true,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "select",
      placeholder: "addedBy",
      name: "addedBy",
      validation: "addedBy",
      showItem: "fullName",
      collection: "addedBy",
      filter: false,
      default: "",
      label: "addedBy",
      required: true,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "subject",
      name: "title",
      validation: "",
      default: "",
      label: "subject",
      required: true,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "textarea",
      placeholder: "message",
      name: "news",
      validation: "",
      default: "",
      label: "message",
      required: true,
      view: true,
      add: false,
      update: false,
    },
    // {
    //   type: "select",
    //   placeholder: "status",
    //   name: "status",
    //   validation: "",
    //   default: "",
    //   showItem: "translate",
    //   label: "status",
    //   required: true,
    //   view: true,
    //   filter: false,
    //   tag: true,
    //   add: false,
    //   update: false,
    //   apiType: "JSON",
    //   selectApi: [
    //     { id: "Draft", value: t("Draft") },
    //     { id: "Published", value: t("Published") },
    //     { id: "Archive", value: t("Archive") },
    //   ],
    // },
    // {
    //   type: "select",
    //   placeholder: "sharedTo",
    //   name: "sharedTo",
    //   validation: "",
    //   default: "",
    //   label: "sharedTo",
    //   showItem: "translate",
    //   required: true,
    //   view: true,
    //   filter: false,
    //   tag: true,
    //   add: false,
    //   update: false,
    //   apiType: "JSON",
    //   selectApi: [
    //     { id: "Employees", value: t("Employees") },
    //     { id: "Department", value: t("Department") },
    //     { id: "All", value: t("All") },
    //   ],
    // },
    // {
    //   type: "multiSelect",
    //   placeholder: "department",
    //   condition: { item: "sharedTo", if: "Department", else: "disabled", then: "enabled" },
    //   name: "department",
    //   validation: "",
    //   showItem: "title",
    //   default: "",
    //   label: "department",
    //   required: true,
    //   filterType: "multiSelect",
    //   view: false,
    //   tag: true,
    //   add: false,
    //   update: false,
    //   apiType: "API",
    //   selectApi: "department/select",
    // },
    // {
    //   type: "multiSelect",
    //   placeholder: "employee",
    //   condition: { item: "sharedTo", if: "Employees", else: "disabled", then: "enabled" },
    //   name: "user",
    //   validation: "",
    //   showItem: "fullName",
    //   default: "",
    //   label: "employee",
    //   required: true,
    //   filterType: "multiSelect",
    //   view: false,
    //   tag: true,
    //   add: false,
    //   update: false,
    //   apiType: "API",
    //   selectApi: "user/select",
    // },
    // {
    //   type: "checkbox",
    //   placeholder: "readReceipt",
    //   name: "readReceipt",
    //   validation: "",
    //   showItem: "",
    //   default: "",
    //   label: "readReceipt",
    //   required: true,
    //   view: false,
    //   tag: true,
    //   add: false,
    //   update: false,
    // },
  ])
  setIsOpenPop(true);
}



  return (
    <Container className="noshadow column">
      {openSettings && (
        <PopupView
          themeColors={themeColors}
          openData={{ data: { settings: "dashboardSettings" } }}
          itemTitle={{ name: "settings", collection: "" }}
          popupData={
            <SettingsBox>
              {dashboardDefault.map((item) => {
                const has = dashboardOrder.some((order) => order === item);
                return (
                  // <Button onClick={() => addDashboard(item)}>{t(item)}</Button>
                  <Checkbox label={t("dash-" + item)} checked={has} onChange={() => addDashboard(item)} />
                );
              })}
            </SettingsBox>
          }
          customClass={"medium"}
          closeModal={() => {
            setOpenSettings(false);
          }}
        ></PopupView>
      )}

      <DndProvider backend={HTML5Backend}>
        {/* {dashboardOrder?.length > 0 && ( */}
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center',padding:"10px 0 30px 0"}}>
          <div style={{backgroundColor:'transparent', color:'#0C3090'}} className="plain">
            <div style={{fontWeight:'bold'}}>{t(formatDateToDayAndDate(date).dayName)}, {formatDateToDayAndDate(date).fullDate}</div>
            <div style={{fontSize:'30px',fontWeight:'bold',marginTop:'10px'}}>Hello {user?.fullName?.split(' ')[0]},</div>
          </div>
          <AddButton onClick={() => setOpenSettings((prev) => !prev)}>
            <GetIcon icon={"editDashboard"}></GetIcon> {t("edit")}
          </AddButton>
        </div>
          <DashboardSection count={((dashboardOrder?.length+1) / 2).toFixed(0)} className="two">
            {/* <div className="">
            <BoxDiv className="radious" style={{border:'2px solid #d6e0ff'}}>
                  <div className="head">
                  <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                    <GetIcon icon={"dashboard"} />
                    {t("dash-" + "dashboard")}
                  </div>
                  </div>
                  
                </BoxDiv>
                </div> */}
            {!dashboardOrder || dashboardOrder.length===0 &&<div className="">
            <BoxDiv className="radious" style={{border:'2px solid #d6e0ff', fontWeight:'bold'}}>
                  <div className="head" style={{borderBottom:'2px solid #d6e0ff'}}>
                  <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                    <GetIcon icon={"time"} />
                    <span className="sub">{t("startClock")}</span>
                  </div>
                  </div>
                  <BoxDiv className="plain">
                  <div style={{marginLeft:"10px",display:'flex', flexDirection:'column',gap:'10px'}}>
                    <ToggleContainer key={`${user?.username}`} style={{width:'50%',height:'80px'}}>
                      <ToggleInput
                        type="checkbox"
                        checked={user?.boardStatus ?? false}
                        onChange={changeClock}
                        className="employee"
                      />
                      <ToggleSlider className="employee" />
                    </ToggleContainer>
                  </div>
                  </BoxDiv>
                </BoxDiv>
                </div>}
                {dashboardOrder.map((page, index) => (
                  index === parseInt(dashboardOrder?.length/2) ? (
                    <>
                    {generateView({ data: organisedData[page] ?? [], type: page, index })}
                    <div key={index} className="">
                    <BoxDiv className="radious" style={{border:'2px solid #d6e0ff', fontWeight:'bold'}}>
                  <div className="head" style={{borderBottom:'2px solid #d6e0ff'}}>
                  <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                    <GetIcon icon={"time"} />
                    <span className="sub">{t("startClock")}</span>
                  </div>
                  </div>
                  <BoxDiv className="plain">
                  <div style={{marginLeft:"10px",display:'flex', flexDirection:'column',gap:'10px'}}>
                    <ToggleContainer key={`${user?.username}`} style={{width:'50%',height:'80px'}}>
                      <ToggleInput
                        type="checkbox"
                        checked={user?.boardStatus ?? false}
                        onChange={changeClock}
                        className="employee"
                      />
                      <ToggleSlider className="employee" />
                    </ToggleContainer>
                  </div>
                  </BoxDiv>
                </BoxDiv>
                    </div>
                    </>
                  ) : (
                    generateView({ data: organisedData[page] ?? [], type: page, index })
                  )
                ))}

          </DashboardSection>
        {/* )} */}
      </DndProvider>
      {isOpenPop && (
        <PopupView
          // Popup data is a JSX element which is binding to the Popup Data Area like HOC
          popupData={<DisplayInformations udpateView={false} isEditingHandler={false} actions={null} setMessage={null} setLoaderBox={null} formMode={"normal"} formView={"normal"} attributes={attributes} data={openData} api={"api"} tabName={openDataTitle} />}
          // themeColors={themeColors}
          closeModal={() => {
            setIsOpenPop(false);
          }}
          setMessage={null}
          setLoaderBox={null}
          profileImage={null}
          itemTitle={openDataTitle}
          openData={{data:openData}} // Pass selected item data to the popup for setting the time and taking menu id and other required data from the list item
          customClass={"normal"}
        ></PopupView>
      )}
    </Container>
  );
};

export default withLayout(Dashboard);
